module.exports = __webpack_public_path__ + "static/img/printed-img-02@m.b790831.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/genesis-shop/printed-img-02@m.png
// module id = pa2H
// module chunks = 0